import { axiosAjax } from './common'

export default {
	// get current team info
	getCurrent() {
		return axiosAjax('/current_company')
	},
	// set current team
	setTeam(params) {
		return axiosAjax('/current_company', 'patch', params)
	},
	// get team list （old）
	getList(params) {
		return axiosAjax('/account', 'get', params)
	},
	// get team member list
	getMemberList(params) {
		return axiosAjax('/v1/account/list', 'get', params)
	},
	// add team member
	addMember(params) {
		return axiosAjax('/v1/account', 'post', params)
	},
	// get member info
	getMember(id) {
		return axiosAjax('/account/' + id)
	},
	// edit member info
	editMember(params) {
		console.log('--pa', params)
		return axiosAjax('/v1/account/' + params.data.id, 'patch', params.data)
	},
	// delete member
	deleteMember(id) {
		return axiosAjax('/v1/account/' + id, 'delete')
	},
	// get team group list
	getGroupList(params) {
		return axiosAjax('/v1/group/list', 'get', params)
	},
	// get team group list
	getGroupMemberList(params) {
		console.log('--params--', params)
		return axiosAjax('/v1/group/members/' + params.id, 'get', { params: params.data })
	},
	// add team group
	addGroup(params) {
		return axiosAjax('/v1/group', 'post', params)
	},
	// edit group info
	editGroup(params) {
		return axiosAjax('/v1/group/' + params.group_id, 'patch', params.data)
	},
	// delete group
	deleteGroup(id) {
		return axiosAjax('/v1/group/' + id, 'delete')
	},
	// get group members
	getGroup(params) {
		return axiosAjax('/group/' + params.id, 'get', { params: params.data })
	},
	// group add member
	groupAddMember(params) {
		return axiosAjax('/v1/group/members/' + params.group_id, 'post', { data: params.data })
	},
	// group delete member
	deleteGroupMember(params) {
		return axiosAjax('/v1/group/members/' + params.group_id, 'delete', { data: params.data })
	},
	// get company statistic
	getStatistic(params) {
		// return axiosAjax('/statistic/company', 'GET', {timeout: 8000, params: params})
		// v1版本
		return axiosAjax('/statistic/company_account_v1', 'GET', { timeout: 8000, params: params })
	},
	// get company account statistic
	getResourceStatistic(params) {
		return axiosAjax('/statistic/company_resource_v1', 'GET', { timeout: 8000, params: params })
	},
	// 获取套餐详情
	getPlanInfo() {
		return axiosAjax('/v1/summary')
	},
	// 更新团队Token
	updateTeamToken() {
		return axiosAjax('/company/update_domain_token', 'post')
	},
	// 解绑EE工作空间
	unBindWorkSpace(params) {
		return axiosAjax('/company/ee/unbind', 'post', params)
	},
	// 重置MFA
	resetMFA(params) {
		return axiosAjax('/v1/account/reset_mfa?account_id=' + params.id, 'get', params)
	},
	// 获取SSO配置
	getSSOConfig() {
		return axiosAjax('/sso/config', 'get')
	},
	// 更新SSO配置
	updateSSOConfig(data) {
		return axiosAjax('/sso/update_config', 'patch', { data })
	},

	// 获取NTP配置
	getNTPConfig() {
		return axiosAjax('/company/ntp', 'get')
	},
	// 更新NTP配置
	updateNTPConfig(data) {
		return axiosAjax('/company/ntp', 'post', { data })
	},
}



// WEBPACK FOOTER //
// ./src/api/team.js